<template>
    <div>       
        <PanelMenu :model="filteredLinks">
            <template #item="{ item }">
        <a class="flex items-center px-4 py-2 cursor-pointer group">
            <span :class="['ml-2', { 'font-semibold': item.items }]">{{ item.label }}</span>
            <span
              v-if="item.badge"
              :title="`${item.badge} outreach draft(s) need attention (failed or overdue)`"
              class="ml-2 inline-flex items-center justify-center min-w-[1.1rem] h-[1.1rem] px-1 rounded-full bg-red-500 text-white text-[10px] font-semibold leading-none"
            >{{ item.badge > 99 ? '99+' : item.badge }}</span>
            <ChevronDownIcon v-if="item.items"
              class="-mr-1 h-5 w-5 text-violet-200"
              aria-hidden="true"
            />
        </a>
    </template>
    </PanelMenu>
    </div>
</template>

<script setup>
import { defineProps, ref, computed, defineEmits, watch } from 'vue';
import { ChevronDownIcon } from '@heroicons/vue/20/solid';
import PanelMenu from 'primevue/panelmenu';
import { Button } from 'primevue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

const props = defineProps([
    'links',
    'userPermissions'
])

const menu = ref(null)
const store = useStore()
const shouldOpen = ref(false)
const router = useRouter()
const emit = defineEmits(['navigate-to-page'])


function canViewLink(link){
    if(link.devOnly){
      return props.userPermissions.isDev 
    }
    if(link.devOrMgmt){
      return props.userPermissions.isDev || props.userPermissions.isManagement
    }
    if(link.accountingLink){
      return props.userPermissions.isDev || props.userPermissions.isManagement || props.userPermissions.isSuperuser || props.userPermissions.isAccountingGroup
    }
    if(link.viewEngagementsInvoicesLink){
      return props.userPermissions.isDev || props.userPermissions.isManagement || props.userPermissions.isSuperuser || props.userPermissions.isAccountingGroup || props.userPermissions.isViewEngagementsInvoices
    }
    return true
  }

  function filterLinks(links){
    links = links.filter((link) => {
        return canViewLink(link)
    })
    links.forEach((link) => {
        if(link.items){
            link.items = filterLinks(link.items)
        }
    })
    return links
  }

  const filteredLinks = computed(() => {
    if(props.links){
        return filterLinks(props.links)
    } else {
        return []
    }
  })


const timeOutId = ref(null)



</script>